import $ from 'jquery';

export const revieveMakeupAdvisor = () => {
    $('.js-makeup-advisor').on('click', () => {
        if (window.rcProps.activeRevievePlugin === 'MAKEUP_ADVISOR'
          || window.rcProps.activeRevievePlugin === 'FOUNDATION_FINDER') {
            openPlugin();
        } else {
            window.activateRevieveMakeupAdvisor(openPlugin);
        }
    });
}

function openPlugin() {
    Revieve.API.show();
    logEngagement(window.location.href, window.rcProps.activeRevievePlugin, 'Open');
}



// WEBPACK FOOTER //
// ./src/scripts/modules/revieve-makeup-advisor.js